import { Component } from 'react';
import { connect } from 'react-redux';
import { Button } from 'react-bootstrap';
import PageTitle from '../../../../../components/common/page-title';
import { getScans, getScansCsv } from '../../../../../actions/scans';
import ScansTable from './scans-table';
import ScansSearch from './scans-search';

class ScansPage extends Component {
  state = {
    query: '',
    valid: true,
    invalid: true,
    failReason: '',
    dateFrom: '',
    dateTo: '',
    page: 1
  };

  handleInputChange = (e) => {
    this.setState({ query: e.target.value });
  };

  handleValidChecked = () => {
    this.setState({ valid: !this.state.valid });
  };

  handleInvalidChecked = () => {
    this.setState({ invalid: !this.state.invalid });
  };

  handleFailReasonChange = (event) => {
    this.setState({ failReason: event.target.value });
  };

  handleDateFromChange = (value) => {
    if (typeof value === 'object') {
      this.setState({ dateFrom: value.format('DD/MM/YYYY') });
    } else {
      this.setState({ dateFrom: '' });
    }
  };

  handleDateToChange = (value) => {
    if (typeof value === 'object') {
      this.setState({ dateTo: value.format('DD/MM/YYYY') });
    } else {
      this.setState({ dateTo: '' });
    }
  };

  handleSearch = () => {
    const { dispatch } = this.props;
    const {
      query, valid, invalid, failReason, dateFrom, dateTo, page
    } = this.state;

    dispatch(getScans(query, valid, invalid, failReason, dateFrom, dateTo, page));
  };

  handlePageChange = (page) => {
    this.setState({ page }, this.handleSearch);
  };

  handleClear = () => {
    this.setState({
      query: '',
      valid: true,
      invalid: true,
      failReason: '',
      dateFrom: '',
      dateTo: '',
    }, this.handleSearch);
  };

  handleDownload = () => {
    const {
      query, valid, invalid, failReason, dateFrom, dateTo
    } = this.state;

    getScansCsv(query, valid, invalid, failReason, dateFrom, dateTo);
  };

  render() {
    const {
      paging, meta, loading, scans
    } = this.props;

    const {
      query, valid, invalid, failReason, dateFrom, dateTo, page
    } = this.state;

    return (
      <div>
        <PageTitle>Scans</PageTitle>
        {loading ? 'Loading...' : (
          <div>
            <ScansSearch
              onClear={this.handleClear}
              onSearch={this.handleSearch}
              onInputChange={this.handleInputChange}
              searchValue={query}
              valid={valid}
              onValidChecked={this.handleValidChecked}
              invalid={invalid}
              onInvalidChecked={this.handleInvalidChecked}
              dateFromValue={dateFrom}
              dateToValue={dateTo}
              onDateFromChange={this.handleDateFromChange}
              onDateToChange={this.handleDateToChange}
              failReasons={meta['fail-reasons']}
              failReason={failReason}
              onFailReasonChange={this.handleFailReasonChange}
            />
            <Button
              className="red-ghost-btn"
              onClick={this.handleDownload}
            >Download scan data
            </Button>
            <ScansTable
              scans={scans}
              currentPage={page}
              onPageChange={this.handlePageChange}
              paging={paging}
            />
          </div>
        )}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  scans: state.scans.scans,
  loading: !state.scans.fetched && state.scans.fetching,
  meta: state.scans.meta,
  paging: state.scans.paging,
});

export default connect(mapStateToProps)(ScansPage);
